@if (batch) {
  ⏳
} @else {
  ...
}
